import { memo, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
//Local files
import { UploaderTitle } from './FillTemplate.styled';
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import FileUploader from 'components/Blobs/FileUploader/FileUploader';
import FillDocList from 'components/FillTemplates/List/List';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useFillTemplates from 'hooks/useFillTemplates';
import useBlob from 'hooks/useBlob';
import useChecksum from 'hooks/useChecksum';
import useCustomSelector from 'hooks/useCustomSelector';
import { appSelectors } from 'features/app';
import { fillTemplatesSelectors } from 'features/fillTemplates';

const FillTemplateDialog = () => {
  const navigate = useNavigate();
  const { closeFillTemplateDialog } = useApp();
  const { createFillTemplate } = useFillTemplates();
  const { processBlob } = useBlob();
  const { processFiles } = useChecksum();
  const { open } = useCustomSelector(appSelectors.getFillTemplateDialogData);
  const fetching = useCustomSelector(fillTemplatesSelectors.fillTemplateIsFetching);
  const [blob, setBlob] = useState(null);

  const handleUpload = (files) => processFiles(files, ({ file, checksum }) => processBlob({ file, checksum }, blob => setBlob(blob)));
  const handleCreateFillTemplate = () => {
    const fillTemplate = { 
      template_attributes : { 
        file: blob.id, 
        name: blob.filename 
      }
    };

    createFillTemplate(fillTemplate)
    .then(({ payload, error }) => {
      if (!error) {
        const { fill_template: { id } }  = payload;
        navigate(`/fill_templates/${id}`);
      }
    })
    .finally(() => onClose())
  };
  const onClose = () => closeFillTemplateDialog();
  const handleExited = () => {
    setBlob(null);
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      otherPaperStyle={{ 
        width: 'min(100%, 560px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        boxShadow: '0 6px 20px rgba(26, 28, 77, .1)',
        borderRadius: '20px',
        padding: '32px 24px',
        margin: '0 auto' 
      }}
      title={<UploaderTitle>Upload a document</UploaderTitle>}
      TransitionProps={{ onExited: handleExited }}
      actions={
        <>
          <Button
            variant='contained'
            size='large'
            disabled={fetching || !!!blob}
            onClick={handleCreateFillTemplate}
          >
            Upload
          </Button>
          <Button
            color='error'
            size='large'
            disabled={fetching}
            onClick={onClose}
          >
            Cancel
          </Button>
        </>
      }
    >
      <>
        {!!!blob ? (
          <FileUploader
            onFilesChange={({ target: { files } }) => handleUpload(files)}
            onDrop={handleUpload}
          />
          ) : (
            <Box>
              <FillDocList
                documents={[blob]}
                onDelete={() => setBlob(null)}
              />
            </Box>
        )}
      </>   
    </BaseDialog>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillTemplateDialog {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);